import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { PRReturnPolozky } from '../polozky';
import { NAME as name, DEPENDENT_TABLES, CRUMB_LABEL_KEY, PRReturnAttachmentFiles, NDPRIJEMKA_STATUS } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

const edit = {
	SkladOzn: null as number | null,
	Text: null as string | null,
	VyrobekndOzn: null as number | null,
	UzavreniDat: null as string | null,
	DodFaktNr: null as string | null,
	DodListNr: null as string | null,
	DodavatelId: null as number | null,
	DodavatelIdText: null as string | null,
	DokladId: null as number | null,
	EditDat: null as string | null,
	EditPracId: null as number | null,
	EditPracIdText: null as string | null,
	EdlPrp: null as number | null,
	JednotekCil: null as number | null,
	JednotekZdr: null as number | null,
	MenaIdCil: null as number | null,
	MenaIdZdr: null as number | null,
	NcCelkPrp: null as boolean | null,
	NcKontrsouc: null as number | null,
	NcKorDat: null as string | null,
	NdprijemPzn: null as number | null,
	ObjednNr: null as number | null,
	ObjednVyrOzn: null as string | null,
	PozadavekDruh: null as string | null,
	PrijemkaId: null as number | null,
	PrijemkaNr: null as number | null,
	PrijemkaPfx: null as string | null,
	Status: null as NDPRIJEMKA_STATUS | null,
	StatusText: null as string | null,
	VstupDat: null as string | null,
	VstupPracId: null as number | null,
	VstupPracIdText: null as string | null,
	VyrazenDat: null as string | null,
	EdlFileType: null as string | null | string[],
	Edl: null as boolean | null,
	EdlId: null as number | null,
	EdlTableRows: null as object | null,
	CanMakeDobropis: null as boolean | null,
	ProrderId: null as number | null,
	IsFromPROrderload: null as boolean | null,
	PRInvoiceNr: null as number | null,
	PRInvoicePfx: null as string | null,
	PRInvoiceId: null as number | null,
	PRInvoiceDate: null as string | null,
	PrInvoiceId: null as number | null,
	Remarks: null as string | null,
	PrPartReturnId: null as number | null,
	StatusId: null as number | null,
	ItemData: [] as any[],
	Supplier: null as string | null,

};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
	},
	edit,
	localState: {},
	depTableNames: DEPENDENT_TABLES,
	depTableSettings: {
		[PRReturnPolozky.name]: { filter(state) { return { PrPartReturnId: state.edit.PrPartReturnId }; } },
		[PRReturnAttachmentFiles]: { filter(state) { return { PrPartReturnId: state.edit.PrPartReturnId }; } },
	},
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[editMutations.ND_PRIJEMKA_DODAVATEL_SELECT_MAPPER](state, { data }) {
			state.edit.DodavatelId = data.value;
			state.edit.DodavatelIdText = data.text;
		},
		[editMutations.ND_PR_RETURN_PRINVOICE_SELECT_MAPPER](state, { data }) {
			state.edit.PrInvoiceId = data.PrijemkaNr;
			state.edit.PrijemkaId = data.PrijemkaId;
			state.edit.PrijemkaNr = data.PrijemkaNr;
			state.edit.DodavatelId = data.DodavatelId;
			state.edit.DodavatelIdText = data.Supplier;
		},
	},
	props: {
		mode: null,
		filter: {
			PrPartReturnId: null as number | null,
			paymentId: null as number | null,
			DodavatelId: null as number | null,
		},
	},
});
